const cognitoConfig = {
  // Amazon Cognito Identity Pool ID
  identityPoolId: '',
  // Amazon Cognito Region
  region: process.env.REACT_APP_REGION,
  // Amazon Cognito User Pool ID
  userPoolId: process.env.REACT_APP_USERPOOL_ID,
  // Amazon Cognito Web Client ID
  userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
  mandatorySignIn: true
}

const config = {
  cognito: cognitoConfig,
  // API
  API: process.env.REACT_APP_API
}

export default {
  ...config
};
